<ion-content class="modal-outher-container">
  <ion-grid class="modal-inner-container">
    <ion-row>
      <ion-col>
        <app-modal-header 
          header="{{spaceHader}}" 
          (close)="back()"
        ></app-modal-header>

        <ion-grid>
          <ion-row>
            <ion-col size="12" size-md="6">
              <div class="control-display margin-top-0">
                <ion-label>{{ "SPACE.START" | translate }}:</ion-label>
                <app-date-time-picker 
                  placeholder="{{ 'ADD_INVITATION.SELECT_DATE' | translate }}"
                  [value]="assignmentDetails.startTime"
                  [min]="assignmentDetails.startTime"
                  [max]="assignmentDetails.endTime" 
                  [disabled]="true"
                ></app-date-time-picker>
              </div>
            </ion-col>
            <ion-col size="12" size-md="6">
              <div class="control-display margin-top-0">
                <ion-label>{{ "SPACE.END" | translate }}:</ion-label>
                <app-date-time-picker 
                  placeholder="{{ 'ADD_INVITATION.SELECT_DATE' | translate }}"
                  [value]="assignmentDetails.endTime" 
                  [min]="assignmentDetails.startTime"
                  [max]="assignmentDetails.endTime" 
                  [disabled]="true"
                ></app-date-time-picker>
              </div>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="12">
              <app-select-user 
                [selectedUser]="userService.userStorage" 
                (changeValueEvent)="setUser($event)"
              ></app-select-user>
              <ion-item class="input" lines="none">
                <ion-button 
                  class="button-margin-top-md" 
                  (click)="save()" 
                  size="medium" 
                  slot="end"
                  [disabled]="selectedUser ? 'false' : 'true'"
                >
                  {{ "SAVE" | translate }}
                </ion-button>
              </ion-item>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>